// extracted by mini-css-extract-plugin
module.exports = {"confirmBtn":"Button_confirmBtn__1Sz8i","cancelBtn":"Button_cancelBtn__4vBNQ","Remove":"Button_Remove__265fr"};